import React from 'react';
import { Content } from 'rsuite';
import { useSelector } from 'react-redux';
import { Context } from '../../../../../constants/download-request';
import PageHeader from '../../../../../components/PageHeader';
import PageLayout from '../../../../../components/Reports/PageLayout';
import DownloadRequestList from '../../../../../containers/DownloadRequestList';
import DownloadRequestSearch from '../../../../../containers/DownloadRequestSearch';
import AccessControl from '../../../../../components/AccessControl';
import AccessDenied from '../../../../../components/AccessDenied';
import history from '../../../../history';
import { outreachAggregateReportViewPath } from '../../../../Paths';
import { hasFullAccess, viewAccess } from '../../../../../helpers/permission';
import { OUTREACH_AGG_REPORT } from '../../../../../constants/permissions';
import { getUserPermissionsAsMap } from '../../../../../redux/selectors/permission';

export default () => {
  const handleOnView = ({ id }) => {
    history.push(outreachAggregateReportViewPath.replace(':id', id));
  };
  const permissions = useSelector(getUserPermissionsAsMap);

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={viewAccess(OUTREACH_AGG_REPORT)}
        fallback={<AccessDenied />}
      >
        <PageHeader title="Report History" />
        <Content>
          <DownloadRequestSearch context={Context.OUTREACH_AGGREGATE_REPORT} />
          <DownloadRequestList
            context={Context.OUTREACH_AGGREGATE_REPORT}
            onView={handleOnView}
            allowDelete={hasFullAccess(OUTREACH_AGG_REPORT, permissions)}
          />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
